import ClientRegistration from './ClientRegistration';

export default ClientRegistration;
